import {
  DataGridFilter,
  DataGridFilters,
  DataGridOptions,
} from "fe-shared/src/components/DataGrid/modules/types";
import { format } from "date-fns";
import { DataGridFiltersParams, DataGridRequestParams } from "types";

export const DEFAULT_SORT_FIELD = "submittedDate";

const sortFieldMap: { [key: string]: string } = {
  submittedDate: "SubmittedDate",
  requestNumber: "RequestNumber",
  participants: "SourceCompanyName",
  municipalityName: "MunicipalityName",
  zoneName: "ZoneName",
  priorityCode: "PriorityId",
  createdByFullName: "CreatedByFullName",
  pickupDate: "PickupDateFrom",
  statusCode: "StatusCode",
  assignedToFullName: "AssignedToFullName",
};

const filterFieldMap: { [key: string]: string } = {
  participants: "ParticipantName",
  warning: "IsFlagged",
};

const getFilterValues = (filter: DataGridFilter) => {
  switch (filter.type) {
    case "dateRangeFilter": {
      const [startDate, endDate] = filter.value;

      if (startDate) {
        return [startDate, endDate || startDate]
          .map((date) => new Date(date).toJSON())
          .join(",");
      }
      return "";
    }
    case "selectFilter":
      if (filter.value.length) {
        return filter.value.join(",");
      }
      return "";
    default:
      return filter.value;
  }
};

export const getRequestParams = (
  filters: DataGridFilters,
  options: DataGridOptions
): DataGridRequestParams => ({
  filteringParameters: Object.keys(filters).reduce(
    (acc: DataGridFiltersParams[], propertyName: string) => {
      const filter = filters[propertyName];
      const values = getFilterValues(filter);

      if (values) {
        acc.push({
          propertyName: filterFieldMap[propertyName] || propertyName,
          // The grid groups the number as 637 486 4285, so the user types the spaces back;
          // the column stores it unspaced and the server matches with like.
          values:
            propertyName === "requestNumber"
              ? values.replace(/\s/g, "")
              : values,
        });
      }
      return acc;
    },
    []
  ),
  sortingBy: {
    propertyName:
      sortFieldMap[options.sortField] || sortFieldMap[DEFAULT_SORT_FIELD],
    isAscending: options.sortDirection === "asc",
  },
});

export default getRequestParams;

export const getFormattedDate = (date?: string) =>
  format(new Date(date || Date.now()), "MMM d, yyyy");
